<template>
  <el-card
    :body-style="bodyStyle"
    shadow="never"
    :class="[
      isCarousel
        ? isMobileLayout && carouselType === 2
          ? 'carousel__video--width__mobile'
          : 'carousel__width'
        : '',
      'mb-40',
    ]"
  >
    <el-row :gutter="5" class="blog-list-view" style="background-color: #fff;">
      <router-link :to="blogView">
        <el-col :xs="12" :sm="12" :md="14" class="text-left">
          <span class="blog-title">
            {{ title }}
          </span>
        </el-col>
        <el-col :xs="8" :sm="8" :md="5" class="text-left">
          <span class="blog-author">
            {{ relatedProviders }}
          </span>
        </el-col>
        <el-col :xs="5" :sm="5" :md="5" class="text-right blog-date">
          <span class="blog-published-date">
            {{ publishedDate }}
          </span>
        </el-col>
        <el-col :md="24">
          <el-divider class="m-0 mt-6 mb-6" />
        </el-col>
      </router-link>
    </el-row>
  </el-card>
</template>

<script>
import { get, isEmpty } from "@/utils/lodash";
import layoutUtils from "@/utils/layout-utils";

export default {
  props: {
    blog: {
      type: Object,
      default: () => {},
    },
    isFilterVisible: {
      type: Boolean,
      default: true,
    },
    isCarousel: {
      type: Boolean,
      default: false,
    },
    carouselType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  computed: {
    blogView() {
      return {
        name: "blog",
        params: {
          slug: get(this.blog, "slug") || get(this.blog, "id", ""),
        },
      };
    },
    title() {
      return get(this.blog, "title");
    },
    author() {
      const author = `${get(this.blog, "user.firstName")} ${get(
        this.blog,
        "user.lastName"
      )}`;

      return author != null ? author : "";
    },
    relatedProviders() {
      var author = '';
      if(get(this.blog.relatedProviders[0], "name") != undefined){
         author = `${get(this.blog.relatedProviders[0], "name")} `;
      }
      return author != null ? author : "";
    },
    publishedDate(){
      var date = get(this.blog, "publishedDate");
      if(!isEmpty(date)){
        var d = new Date(date);
        const day = d.getDate().toString().padStart(2, "0");
        const month = d.toLocaleString(this.$i18n.locale, {
                      month: "short",
                      }).substring(0, 3);
        const year = d.getFullYear();
        return `${day} ${month} ${year} `;
      }
      return '';
    },
    bodyStyle() {
      if (!layoutUtils.isMobileLayout(this.$mq) && !this.isFilterVisible) {
        return {
          padding: "0 0 0 20px",
        };
      }
      return {
        padding: "0px",
      };
    },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables.scss";
$carousel-image-size: 356px;
$carousel-image-size-mobile: 312px;

.blog-author {
  float: right;
}
.el-card {
  border-radius: 0px;
  border: 0;
  background-color: rgba(39, 36, 33);
  color: #333333;
  line-height: normal;
  margin: auto;
}
.blog-background {
  border: 0 solid $color-on-background;
  background-size: contain !important;
}
.blog-background__carousel {
  border: 0 solid $color-background;
  background-color: $color-background;
}

.blog__detail {
  height: 86px;

  & div {
    background-color: rgba(255, 255, 255, 0);
    color: $color-on-background-area1;
    box-sizing: border-box;
    text-align: left;
    line-height: normal;
  }
}
.blog__title {
  color: $color-on-background !important;
  letter-spacing: 0.25px !important;
}
// .image-container {
//   position: relative;
// }
.carousel__image-size {
  // sm -
  @media screen and (max-width: $media-md) {
    width: 188px;
    height: 110px !important;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    width: 296px;
    height: 181px;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    width: 356px;
    height: 212px;
  }
}
.carousel__width {
  // sm -
  @media screen and (max-width: $media-md) {
    width: $carousel-image-size-mobile;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    width: $carousel-image-size-mobile;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    width: $carousel-image-size;
  }
}
.carousel__video--width {
  // sm -
  @media screen and (max-width: $media-md) {
    width: 188px;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    width: 298px;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    width: 350px;
  }
}
.carousel__video--height {
  // sm -
  @media screen and (max-width: $media-md) {
    height: 110px !important;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    height: 181px;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    height: 212px;
  }
}
.carousel__texte--width {
  // sm -
  @media screen and (max-width: $media-lg) {
    width: 300px;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    width: 350px;
  }
}

.carousel__texte--height {
  // sm -
  @media screen and (max-width: $media-lg) {
    height: 300px;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    height: 350px;
  }
}

.carousel__video--width__mobile {
  max-width: 382px;
}

.carousel__video--title {
  letter-spacing: 0.15px !important;
  // height: 24px;
  width: 184px;
  font-family: "Futura Std ", "Futura Std", sans-serif !important;
  line-height: 20px;
}

.carousel__video--theme {
  width: 184px;
  height: 28px;
  background-color: rgba(255, 255, 255, 0);
  box-sizing: border-box;
  font-family: "Futura Std ", "Futura Std", sans-serif;
  font-weight: 300;
  color: rgba(39, 36, 33, 0.7);
  text-align: left;
  line-height: 14px;
  letter-spacing: 1.5px;
}
.thumbnail-image {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.subtitle2 {
  color: rgba(39, 36, 33, 0.7) !important;
}
.bg-transparent {
  background: transparent;
}
.carousel__video--wrapper {
  @media screen and (max-width: $media-sm) {
    width: unset !important ;
    display: flex;
  }
}
.carousel__video--detail,
.carousel__video--detail div {
  @media screen and (max-width: $media-sm) {
    width: unset !important ;
    // max-width: 144px;
  }
}
.blog-published-date{
  color: rgba(39, 36, 33, 0.7);
  font-size: 12px;
}
.blog-date {
  float: right;
}
</style>
